import React, { useEffect } from 'react';
import styled from 'styled-components';
import { BsFillBasket2Fill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { getCart } from '@app/product/redux/selectors';
import { get_cart } from '@app/product/redux/reducer';
import { getLoggedInCart } from '@app/basket/redux/selectors';
import { get_logged_in_cart } from '@app/basket/redux/reducer';

const BaseButton = styled.div`
  background-color: #549a9a;
  justify-content: center;
  color: #fff;
  display: flex;
  position: fixed;
  margin-bottom: 20px;
  margin-right: 20px;
  align-items: center;
  cursor: pointer;
  border-radius: 100%;
  bottom: 0;
  right: 0;
  z-index: 200;
  border: none;
  width: 3em;
  height: 3em;
  padding: 0.5rem;
  box-shadow: -1px 3px 22px 3px rgba(141, 152, 152, 0.7);
  transition: all 0.5s ease-in-out;

  @media screen and (max-width: 992px) {
    font-size: 16px;
  }
  @media screen and (min-width: 1024px) and (max-width: 1400px) {
    font-size: 20px;
  }

  .indicator {
    position: absolute;
    top: 0%;
    right: 0%;
    left: 60%;
    bottom: 60%;
    background-color: #d92d20;
    border: 1px solid #fff;
    color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.4s ease-out;
  }
`;

export const CartButton = () => {
  const token = localStorage.getItem('x-access-token');
  const cart = token ? useSelector(getLoggedInCart) : useSelector(getCart);
  const dispatch = useDispatch();
  const partner = localStorage.getItem('partner_id');

  useEffect(() => {
    dispatch(get_cart(partner));
    dispatch(get_logged_in_cart(partner));
  }, [dispatch, partner]);

  return (
    <BaseButton data-badge="20">
      {cart <= 0 ? ' ' : <div className="indicator">{cart?.length}</div>}

      <BsFillBasket2Fill color="#fff" size={30} />
    </BaseButton>
  );
};
